import { Icon, IconName, Pressable } from '@rbilabs/universal-components';
import Clipboard from '@react-native-clipboard/clipboard';
import { Typography } from 'ucl/components/text/Typography';

import { toaster } from 'components/toaster/toaster';
import type { TextVariant } from 'styles/constants/fonts';

export const CopyButton = (props: {
  label: string;
  textToCopy: string;
  variant?: TextVariant;
  iconName?: IconName;
}) => {
  return (
    <Pressable
      onPress={() => {
        toaster.neutral('Copied to clipboard');
        Clipboard.setString(props.textToCopy);
      }}
      flexDirection="row"
      alignItems="center"
    >
      <Typography variant={props.variant} mt="$2" mb="$2">
        {props.label}
      </Typography>
      {props.iconName ? <Icon name={props.iconName} size="xs" marginLeft="$2" /> : null}
    </Pressable>
  );
};
